import { UIMatch } from 'react-router-dom';
import { RouteHandleBreadcrumb } from '@/types/route-handle-breadcrumb';
import { Breadcrumb } from '../types/breadcrumb';

export const matchToCrumb =
  ({
    pathname: locationPathname,
    titles,
  }: {
    pathname: string;
    titles: Record<string, string>;
  }) =>
  ({
    data,
    handle,
    pathname,
  }: UIMatch<unknown, { crumb: RouteHandleBreadcrumb }>):
    | Breadcrumb
    | 'hide' => {
    const crumb =
      typeof handle.crumb === 'function' ? handle.crumb(data) : handle.crumb;

    if ('hide' in crumb) {
      return 'hide';
    }

    const to = crumb.to ?? pathname;
    const display =
      typeof crumb.key === 'string' ? titles[crumb.key] : crumb.display;
    return {
      display,
      isCurrent: to === locationPathname,
      isRoot: crumb.isRoot ?? false,
      to,
    };
  };
